(function($) {
  /* 10 — von AE004 uebernommen, und das ist hier keine Abschreiberei:
     nach dem Zuschnitt ist das Verhaeltnis Schrift zu Gravurflaeche bei
     beiden praktisch gleich (A219 42,77 %, AE004 43,43 % der Buehne), die
     dort gemessene Grenze traegt also direkt herueber. 138 px Feldbreite bei
     322 px Buehne, Schrift bis 29,6 px.
     Ziffern sind breiter als Buchstaben — "14.05.2024" passt auch bei 10
     nicht ganz; als Datum bitte 14.05.24 schreiben.
     ⚠️ Der ovale Koerper ist an den Enden verjuengt (Breite : Hoehe
     1,43 : 1), die nutzbare Breite ist also etwas kleiner als die gemessene
     Feldbreite. Bei der Kalibrierung mit ?a219tuner=1 nachziehen. */
  var CHAR_MAX = 10;
  var SYMBOL_COST = 2;
  var SIDE_LABELS = ['Vorderseite', 'Rückseite'];
  var sideModes = ['zeichen', 'zeichen'];
  var previewSideCount = 1;
  var physicalSideMap = [0];

  function setPhysicalSideMap(map) {
    physicalSideMap = Array.isArray(map) && map.length ? map.slice() : [0];
  }

  function getPhysicalSideIndex(uiSideIndex) {
    if (physicalSideMap[uiSideIndex] != null) return physicalSideMap[uiSideIndex];
    return uiSideIndex;
  }

  window.a219SetPhysicalSideMap = setPhysicalSideMap;


  /* Reglerfenster ?a219tuner=1 — docs/TUNER-VOLLAUSBAU.md.
     Alles neutral (0/1): der Einbau veraendert kein bestehendes Bild.
     Steht bewusst auf Modulebene: innerhalb der Renderfunktion
     wuerde es bei jedem Aufbau neu entstehen und jeden gedrehten
     Wert sofort verwerfen. */
  /* ==================================================================
     REGLER-TABELLEN (docs/TUNER-VOLLAUSBAU.md, zwei Ebenen)

         Endwert = Einzelwert ⊕ Gesamtebene

     Die Einzelwerte sind NEUTRAL vorbelegt (0 bzw. ×1). Wer alle Motive
     einzeln getunt hat, kann danach immer noch die Gesamtebene anfassen und
     alles gemeinsam verschieben — genau das ist der Unterschied zwischen
     einer Ueberlagerung und einem Ersatzwert.
     ================================================================== */
  var A219_TUNE = { blockDx: 0, blockDy: 0, blockScale: 1, motivDx: 0, motivDy: 0, motivScale: 1, breiteFaktor: 1 };

  /* EINZELEBENE Block-Lage je Gravurflaeche. Vorder- und Rueckseite sitzen auf
     verschieden zugeschnittenen Bildern und sind getrennt retuschiert; wer die
     Rueckseite einen Hauch tiefer will, darf dafuer nicht die Vorderseite
     mitziehen muessen. Neutral vorbelegt — A219_TUNE.blockDx/Dy bleibt die
     Gesamtebene DARUEBER und wirkt weiterhin auf alle drei. */
  var A219_SLOT_NUDGE = {
    einzel: { x: 0, y: -0.6 },
    paar_oben: { x: 0, y: 0 },
    paar_unten: { x: 0, y: 0 }
  };

  /* Breitenkappe je Gravurflaeche, Faktor auf die gemessene Feldbreite (LB).
     Neutral = 1. Die Gesamtebene ist A219_TUNE.breiteFaktor. */
  var A219_BREITE_BY_SLOT = { einzel: 1, paar_oben: 1, paar_unten: 1 };

  /* ==================================================================
     ZEICHENZAHL × SCHRIFT — der Ladenstandard (41 Produkte)

         <SKU>_TPM_BY_FONT[Schrift][Stufe] = { text, icon, gap }
         Stufen: '1' · '2' · '3-5' · '6-8' · '9+'

     Warum das hier bis 2026-08-21 GEFEHLT hat und warum es ein Fehler war:
     A219 rechnete EINE Schriftgroesse fuer jede Laenge. „Ida" und
     „Maximilian" kamen gleich gross heraus; der lange Name lief in die
     Breitenkappe und wurde mit „…" abgeschnitten. Yins Basistabelle
     (product-tuner-Skill) sagt fuer G02 dagegen 26 pt bei einem Zeichen und
     9 pt bei zehn — die Schrift schrumpft mit der Laenge, statt zu kappen.
     Nebenwirkung des Fehlens: `scripts/tuner_verhaeltnis.py a219` gab gar
     nichts aus, eine der drei Pflichtpruefungen lief also ins Leere.

     text/icon sind % der Buehne, gap ist der seitliche Abstand des Motivs in
     px. Die Werte folgen Yins Kurve fuer G02 bzw. G05, verankert am bisher
     gerenderten Wert: der paar-Zuschnitt zeigte 8,66 cqw, das entspricht der
     Stufe '3-5' (vier Zeichen). Die uebrigen Stufen sind daraus mit dem
     Verhaeltnis ihrer Kurve gerechnet — nachrechenbar in
     scripts/a219/zeichenkurve.py. */
  var A219_TPM_BY_FONT = {
    G02: {
      '1': { text: 15.46, icon: 15.48, gap: 1 },
      '2': { text: 14.31, icon: 13.69, gap: 1 },
      '3-5': { text: 10.7, icon: 9.53, gap: 1 },
      '6-8': { text: 9.61, icon: 7.14, gap: 1 },
      '9+': { text: 8.94, icon: 5.36, gap: 1 }
    },
    G05: {
      '1': { text: 17.17, icon: 15.25, gap: 1 },
      '2': { text: 16.21, icon: 13.62, gap: 1 },
      '3-5': { text: 11.59, icon: 9.53, gap: 1 },
      '6-8': { text: 10.65, icon: 7.62, gap: 1 },
      '9+': { text: 9.9, icon: 5.45, gap: 1 }
    }
  };

  var A219_STUFEN = ['1', '2', '3-5', '6-8', '9+'];

  /* Die Stufe zaehlt GEWICHTETE Zeichen — ein Motiv kostet zwei, genau wie
     bei der Zeichengrenze. Sonst faellt „Ida(Herz)" in eine andere Stufe als
     die Kappe annimmt. */
  function a219Stufe(text) {
    var n = weightedLength(text || '');
    if (n <= 1) return '1';
    if (n === 2) return '2';
    if (n <= 5) return '3-5';
    if (n <= 8) return '6-8';
    return '9+';
  }

  function a219Tpm(font, stufe) {
    var f = A219_TPM_BY_FONT[font] || A219_TPM_BY_FONT.G02;
    return f[stufe] || f['3-5'];
  }

  /* Lage der Gravur JE SCHRIFT (Yin 2026-08-23: „每个字体的 x y 单独调整").
     Zwei Schriften bauen unterschiedlich: NirmalaS steht aufrecht und sitzt
     satt auf der Grundlinie, „Bradley Hand ITC" ist eine Schreibschrift mit
     schraeger Achse und anderem optischen Schwerpunkt — auf demselben Anker
     wirkt die eine mittig und die andere verrutscht. Das ist dieselbe Regel,
     die der Tuner-Skill fuer Kombi-Vorlagen festhaelt (harte Regel sieben:
     X/Y je Schriftcode getrennt speichern), hier auf die eine Textstelle
     angewandt.

     EINZELEBENE: neutral vorbelegt und additiv. Darueber liegen unveraendert
     der Slot-Nudge (je Gravurflaeche) und die Gesamtebene A219_TUNE.blockDx/Dy
     — wer alle Schriften einzeln gestellt hat, kann danach immer noch alles
     gemeinsam verschieben. */
  var A219_TEXT_NUDGE_BY_FONT = {
    G02: { x: 0, y: 0 },
    G05: { x: 0, y: 0.8 }
  };

  function a219SchriftNudge(font) {
    var n = A219_TEXT_NUDGE_BY_FONT[font];
    if (!n) n = A219_TEXT_NUDGE_BY_FONT[font] = { x: 0, y: 0 };
    return n;
  }

  /* D2 — Text-Größe je Schrift, Faktor UEBER der Zeichenzahl-Tabelle. */
  var A219_TEXT_SIZE_BY_FONT = { G02: 1, G05: 1 };

  /* D1 — Motiv-Größe je Motiv, Faktor ueber dem Stufenwert. */
  var A219_ICON_SIZE = { W01: 1.177, W02: 1.019, W03: 1.136, W05: 1.471, W06: 1.31, W07: 1.439, W09: 1.285, W27: 1.298, W31: 1.177, W36: 1.734, W41: 1.441 };

  /* D3 — Abstand zwischen Schrift und Motiv, je Schrift × Motiv, in px.
     Kein Wert = der gap der aktuellen Stufe.

     ⚠️ Der Name ist der ladenweit vereinbarte (`<P>_TPM_ABSTAND_BY_FONT_ICON`),
     nicht irgendeiner: scripts/tuner_audit.py sucht fuer die Vorlage
     `text_plus_motiv` genau danach. Hier stand zuerst ein selbst erfundenes
     `A219_GAP_BY_FONT_ICON` — die Pruefung meldete D3 daraufhin als fehlend,
     obwohl der Regler da war. HA001 wurde am 2026-08-19 aus demselben Grund
     umbenannt. Eine Konvention, die nur die Haelfte der Produkte einhaelt,
     ist keine. */
  var A219_TPM_ABSTAND_BY_FONT_ICON = {
    G02: {},
    G05: {}
  };

  function a219IconFaktor(code) {
    var v = A219_ICON_SIZE[code];
    return typeof v === 'number' ? v : 1;
  }

  function a219Gap(font, code, stufe) {
    var f = A219_TPM_ABSTAND_BY_FONT_ICON[font];
    var v = f && f[code];
    return typeof v === 'number' ? v : a219Tpm(font, stufe).gap;
  }
  /* Schriftwahl seit 2026-08-21 (Yin: „这个鱼给 G02 和 G05 字体 10 个字符").
     Vorher stand hier EINE feste Schrift. Die Familien sind die ladenweit
     eingesetzten — in 17 bzw. 16 anderen Snippets steht Zeichen fuer Zeichen
     dasselbe, deshalb hier nicht neu erfunden. Reihenfolge = Anzeigereihenfolge.

     ⚠️ Beide Schreibweisen unten sind die im Laden ueblichen und werden von
     scripts/tuner_audit.py erkannt: die Freigabeliste `<SKU>_ALLOWED_FONTS`
     und die Familienzuordnung `G02: '…'`. Eine eigene Form (etwa `code:`)
     laesst die Schriftzaehlung auf 0 fallen — dann meldet die Pruefung D2 und
     D3 als „nicht gefordert" und das Produkt sieht satt aus, obwohl beide
     Reglerfamilien fehlen. */
  var A219_ALLOWED_FONTS = ['G02', 'G05'];
  var A219_FONT_FAMILIEN = {
    G02: 'NirmalaS, sans-serif',
    G05: '"Bradley Hand ITC", sans-serif'
  };
  var A219_FONTS = A219_ALLOWED_FONTS.map(function (c) {
    return { code: c, family: A219_FONT_FAMILIEN[c] };
  });

  /* Die Schrift gilt GLOBAL fuer das ganze Armband (Standard §1.4): eine
     Aenderung an einer Stelle schlaegt auf beide Seiten durch. Diese Variable
     ist die einzige Wahrheit; das Eingabefeld traegt sie zusaetzlich als
     data-font-family, weil das schon vor der Schriftwahl so war und andere
     Ketten es lesen koennten. */
  var a219GlobalFont = 'G02';

  function a219FontFamily(code) {
    for (var i = 0; i < A219_FONTS.length; i++) {
      if (A219_FONTS[i].code === code) return A219_FONTS[i].family;
    }
    return A219_FONTS[0].family;
  }

  /* Behaelt den alten Namen und die alte Form, damit jede Stelle, die frueher
     die feste Schrift gelesen hat, unveraendert weiterlaeuft — nur ist der
     Wert jetzt die GEWAEHLTE Schrift statt einer Konstanten. */
  var A219_FONT = {
    get name() { return a219GlobalFont; },
    get family() { return a219FontFamily(a219GlobalFont); }
  };

  /* Grundbilder — einzel/paar-Konvention, paar ist uebereinander gestapelt
     (oben = Vorderseite, unten = Rueckseite). DREI Farben.
     Spezifikation, Herleitung und Ausrichtungsregel:
     docs/PREVIEW-UPLOAD-A219.md.

     Die sechs Dateien sind nicht fotografiert, sondern aus Yins drei
     1600er-Vorlagen geschnitten (scripts/a219/zuschnitt.py). Ungeschnitten
     waere das Gravurfeld 18,5 % = 60 px auf der 322-px-Buehne, zehn Zeichen
     darin nicht lesbar — dieselbe Rechnung, die AE004 am 2026-08-19 und
     LW042 am 2026-08-15 auf Zuschnitte gebracht hat.

     Rollback: hier die 1600er-Originale eintragen UND die Ankertabelle auf
     die ungeschnittenen Werte zuruecksetzen (einzel/paar_links/paar_rechts
     left 27,84 / 72,09 · top 48,56 · Feldbreite 18,50 %). Beides zusammen —
     nur eines davon laesst die Gravur irgendwo im Bild sitzen. */
  var A219_PREVIEW_IMAGES = {
    gold: {
      einzel: window.VIV_A219.bild_2026_fisch_a219_gold_einzel_png,
      paar: window.VIV_A219.bild_2026_fisch_a219_gold_paar_png
    },
    silber: {
      einzel: window.VIV_A219.bild_2026_fisch_a219_silber_einzel_png,
      paar: window.VIV_A219.bild_2026_fisch_a219_silber_paar_png
    },
    rosegold: {
      einzel: window.VIV_A219.bild_2026_fisch_a219_rosegold_einzel_png,
      paar: window.VIV_A219.bild_2026_fisch_a219_rosegold_paar_png
    }
  };

  /* Die Zuschnittfenster in Pixeln der 1600er-Vorlage. Zur Laufzeit nicht
     gebraucht — gelesen werden sie von scripts/a219/check-geometrie.py, das
     damit die Anker in die Koordinaten des Originalbildes zurueckrechnet und
     dort prueft, ob einzel und paar_oben immer noch dasselbe Plaettchen
     treffen (Ausrichtungsregel, docs/PREVIEW-UPLOAD-A219.md Abschnitt 4).
     Anders als bei AE004 sind die Fenster nicht quadratisch, deshalb stehen
     Breite und Hoehe getrennt. Das untere Fenster ist die rechte Haelfte der
     Vorlage, es wird im paar-Bild unter das obere gesetzt. */
  var A219_ZUSCHNITT = {
    oben:  { x0: 94,  y0: 613, w: 692, h: 338 },
    unten: { x0: 814, y0: 613, w: 692, h: 338 }
  };

  /* Seitenverhaeltnis der Buehne je Bildsatz — die beiden Bildsaetze sind
     gleich breit, aber verschieden hoch. Wird in a219UpdatePreview als
     CSS-Variable --a219-buehne gesetzt. */
  var A219_BUEHNE = {
    einzel: '692 / 338',
    paar:   '692 / 676'
  };

  /* Schriftgroesse je Bildsatz. Bei AE004 standen hier zwei verschiedene
     Werte, weil seine beiden Zuschnitte verschieden stark zoomten. Bei A219
     sind beide Bildsaetze gleich breit und das Gravurfeld in beiden 42,77 %
     — deshalb ist es zweimal derselbe Wert. Hergeleitet aus AE004s Regel
     mal 42,77/43,43 (einzel) bzw. 42,77/40,61 (paar); beide Wege ergeben
     dasselbe auf zwei Stellen. Die Form bleibt als Tabelle stehen, damit die
     Kalibrierung die beiden spaeter auseinanderziehen kann. */
  var A219_BILDSATZ = {
    einzel: { schrift: 'clamp(18.8px, 9.14cqw, 29.6px)' },
    paar:   { schrift: 'clamp(18.8px, 9.14cqw, 29.6px)' }
  };

  /* ---- Motive: W-Reihe (2026-08-07) --------------------------------------
     Loest die alte C-Reihe ab — Beschluss Yin: eine einzige Icon-Familie im
     ganzen Shop, Referenz ist KE008. Satz = KE008s zehn + Pfote (W31) = elf.
     ★ Bestand kommt jetzt aus DIESER Datei statt aus dem Template-Picker.
     ⚠️ Dateinamen unregelmaessig: w01–w10 zweistellig, ab W11 dreistellig. */
  var A219_SYMBOL_NAMES = {
    'w01.png': 'Mini Herz', 'w02.png': 'Herz', 'w03.png': 'Doppelherz', 'w05.png': 'Infinity',
    'w06.png': 'Jesusfisch', 'w07.png': 'Kreuz', 'w09.png': 'Engel', 'w027.png': 'Anker',
    'w031.png': 'Pfote', 'w036.png': 'Fee', 'w041.png': 'Stern'
  };

  /* Die drei Gravur-Arten. Schluessel, Beschriftung und Beispielzeile sind
     ZEICHEN FUER ZEICHEN die von K530 (K530_LAYOUTS) — der Massstab wird
     abgeschrieben, nicht nachgedichtet.

     ★ Diese drei sind nicht neu: A219 konnte sie schon immer, nur hiessen sie
     im Fenster „Zeichen" und „Symbol" und die Kundin musste selbst darauf
     kommen, dass „Symbol ohne Text" gleich „Nur Motiv" ist. Beweis, dass es
     dieselben drei sind — die Bestell-Eigenschaften heissen heute schon so:
       Vorderseite Text          ->  1_zeile
       Vorderseite Motiv         ->  nur_motiv
       Vorderseite Text + Motiv  ->  text_plus_motiv
     Deshalb aendert diese Runde die Bestell-Ausgabe um kein Byte. */
  var A219_LAYOUTS = [
    { key: '1_zeile',   label: '1 Zeile',   sub: 'z.B. ein Name' },
    { key: 'nur_motiv', label: 'Nur Motiv', sub: 'nur ein Symbol' }
  ];

  /* ⚠️ `text_plus_motiv` ist am 2026-08-23 auf Yins Ansage aus dem ANGEBOT
     genommen worden — die Karte gibt es nicht mehr, neue Bestellungen koennen
     die Kombination nicht mehr erzeugen.

     Was ABSICHTLICH stehen bleibt: composeEngraving / parseEngravingValue /
     symbolOrderRow verstehen „Name(Motiv)" weiterhin. Alte Bestellungen mit
     der Eigenschaft „Vorderseite Text + Motiv" haengen an dieser Kette —
     Gegenkarte, Wiederherstellen und die Vorschau im Auftrags-Restore wuerden
     sonst leer laufen. Angebot wegnehmen heisst nicht Verstehen wegnehmen
     (dieselbe Trennung wie bei KE035, 2026-08-22). */

  var A219_SYMBOLS_FIXED = [
    { code: 'W01', text: 'Mini Herz',  image: window.VIV_A219.bild_w01_png },
    { code: 'W02', text: 'Herz',       image: window.VIV_A219.bild_w02_png },
    { code: 'W03', text: 'Doppelherz', image: window.VIV_A219.bild_w03_png },
    { code: 'W05', text: 'Infinity',   image: window.VIV_A219.bild_w05_png },
    { code: 'W06', text: 'Jesusfisch', image: window.VIV_A219.bild_w06_png },
    { code: 'W07', text: 'Kreuz',      image: window.VIV_A219.bild_w07_png },
    { code: 'W09', text: 'Engel',      image: window.VIV_A219.bild_w09_png },
    { code: 'W27', text: 'Anker',      image: window.VIV_A219.bild_w027_png },
    { code: 'W31', text: 'Pfote',      image: window.VIV_A219.bild_w031_png },
    { code: 'W36', text: 'Fee',        image: window.VIV_A219.bild_w036_png },
    { code: 'W41', text: 'Stern',      image: window.VIV_A219.bild_w041_png }
  ];

  /* Altwerte KH1–KH8 plus die eine echte Umbenennung (Fisch → Jesusfisch);
     ohne den Alias fiele ein altes Motiv im Warenkorb stillschweigend weg. */
  var A219_KH_LEGACY = {
    'KH1': 'Mini Herz', 'KH2': 'Herz', 'KH3': 'Doppelherz', 'KH4': 'Infinity',
    'KH5': 'Jesusfisch', 'KH6': 'Anker', 'KH7': 'Engel', 'KH8': 'Pfote',
    'Fisch': 'Jesusfisch', 'Christenfisch': 'Jesusfisch'
  };

  var a219SymbolsCache = null;

  function imageFileFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function normalizeA219SymbolName(text, imageUrl) {
    var file = imageFileFromUrl(imageUrl);
    if (A219_SYMBOL_NAMES[file]) return A219_SYMBOL_NAMES[file];
    if (A219_KH_LEGACY[text]) return A219_KH_LEGACY[text];
    return text;
  }

  function normalizeA219StoredSymbol(name) {
    if (!name) return '';
    return A219_KH_LEGACY[name] || name;
  }

  /* Nur noch die eigene Liste — kein Umweg mehr ueber den Template-Picker. */
  function loadA219Symbols() {
    if (a219SymbolsCache) return a219SymbolsCache;
    a219SymbolsCache = A219_SYMBOLS_FIXED.slice();
    return a219SymbolsCache;
  }

  /* Bestellwert = "Anzeigename | CODE"; nur ueber den Code findet der
     Auftrags-Parser das Bild wieder. */
  function formatSymbolOrderValue(name) {
    var resolved = normalizeA219StoredSymbol(name);
    if (!resolved) return '';
    var symbols = loadA219Symbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved) {
        return symbols[i].code ? (resolved + ' | ' + symbols[i].code) : resolved;
      }
    }
    return resolved;
  }

  /* ★ Der Feldname entscheidet, ob der Parser ein Bild zeigt: "… Motiv" loest
     den Code auf, "… Text + Motiv" trennt "Text(Motiv)" selbst auf. Ein Motiv
     unter dem Label "Text" bleibt fuer immer bildlos. */
  function symbolOrderRow(title, engraving, withCode) {
    var text = $.trim(engraving.text || '');
    var sym = withCode ? formatSymbolOrderValue(engraving.symbol) : normalizeA219StoredSymbol(engraving.symbol);
    if (text && sym) return { name: title + ' Text + Motiv', value: text + '(' + sym + ')' };
    if (sym)         return { name: title + ' Motiv',        value: sym };
    return { name: title + ' Text', value: text };
  }

  /*
   * ============================================================
   *  GEOMETRIE — gemessen 2026-09-10 an den sechs Grundbildern
   * ============================================================
   *  Alle Zahlen stammen aus scripts/a219/a219_measure.py und gelten fuer die
   *  ZUGESCHNITTENEN Bilder (einzel 692x338, paar 692x676), nicht fuer die
   *  1600er-Vorlagen. Beide Bildsaetze sind gleich BREIT, deshalb ist
   *  "% der Buehne == % des Bildes" in x fuer beide dieselbe Rechnung und
   *  die Schriftgroesse braucht keine Zoom-Korrektur.
   *
   *  Nichts davon ist von AE004 uebernommen — dort haengt ein Fisch mit
   *  Herzfassung an einem anders zugeschnittenen Bild. Genau dieses
   *  Abschreiben hat KE038 beim Erst-Launch verrutschen lassen
   *  (GOTCHAS Nr. 3).
   *
   *  Nachgemessen wird mit:
   *      python3 scripts/a219/zuschnitt.py <quelle> <ziel>   # Bilder bauen
   *      python3 scripts/a219/a219_measure.py <ziel>         # nachmessen
   *  Herleitung und Musterbilder: docs/PREVIEW-UPLOAD-A219.md
   */
  var A219_GEOMETRIE_GEMESSEN = true;

  /* Ein Slot je Gravurflaeche. paar ist UEBEREINANDER gestapelt, deshalb
     unterscheiden sich oben/unten vor allem in 'top'.

     Anker ist die Mitte des ovalen KOERPERS, nicht die Mitte des ganzen
     Plaettchens: die beiden Oesen an den Enden sind verschieden breit und
     ziehen die Bounding-Box-Mitte weg, die Gravur saesse dann schief. Das
     Skript findet die Taillen zwischen Koerper und Oesen ueber das
     Hoehenprofil der Spalten.

     Das untere Plaettchen ist die WAAGERECHTE SPIEGELUNG des oberen, keine
     verschobene Kopie. Gemessen an den bbox-eng zugeschnittenen Plaettchen
     (DEV-PROCESS Nr. 3, Gold, 2026-09-10):
        waagerecht gespiegelt 0,56 · Kopie 21,99 · senkrecht 27,74 · 180 Grad 26,33
     Folge fuer die Kalibrierung: dx und rot werden TROTZDEM NICHT negiert.
     Gespiegelt sind nur Oese und Schwanz; der ovale Koerper — die
     Gravurflaeche — ist selbst waagerecht symmetrisch, und die Gravur wird
     nicht mitgespiegelt. Der Spiegelversatz steckt schon im eigenen 'left'
     von paar_unten (49,06 statt 50,79, also 1,73 pp).

     Alle drei Farben sind deckungsgleich (Abweichung <= 0,15 pp), eine
     Tabelle genuegt fuer Gold, Silber und Roségold.
     einzel und paar_oben sind exakt deckungsgleich: beide werden aus
     demselben Fenster geschnitten (94 | 613 | 692 x 338), einzel IST dieser
     Ausschnitt. Nachgerechnet: 48,52 % von 338 px == 24,26 % von 676 px.

     feldBreite begrenzt die Textzeile, damit sie nicht ueber die verjuengten
     Enden des Ovals hinauslaeuft. Einen gem-Anker gibt es nicht — A219 hat
     keinen Geburtsstein. */
  var A219_SLOT_ANCHOR = {
    einzel:     { top: 48.52, left: 50.79, feldBreite: 42.77, bildsatz: 'einzel' },
    paar_oben:  { top: 24.26, left: 50.79, feldBreite: 42.77, bildsatz: 'paar' },
    paar_unten: { top: 74.26, left: 49.06, feldBreite: 42.77, bildsatz: 'paar' }
  };

  function slotForPhysicalSide(physicalSide) {
    if (usesFrontOnlyPreviewBase()) return 'einzel';
    return physicalSide === 1 ? 'paar_unten' : 'paar_oben';
  }

  function getActiveSideCount() {
    var domCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return domCount > 0 ? domCount : previewSideCount;
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* A219 hat DREI Farben. Die Option heisst im Shop `Fisch Farbe`, die Werte
     sind `Gold`, `Silber`, `Roségold`.
     ⚠️ Reihenfolge: "Roségold" enthaelt "gold". Wird zuerst auf 'gold'
     geprueft, bekommt Roségold still das Gold-Bild — der Klassiker, den
     AE004s Kommentar an dieser Stelle ausdruecklich vorhergesagt hat. */
  function getColorKeyFromOption1() {
    var label = ($('[name="option1"]').attr('data-value') || '').toLowerCase();
    if (label.indexOf('ros') !== -1) return 'rosegold';
    if (label.indexOf('gold') !== -1) return 'gold';
    return 'silber';
  }

  function ensureA219GravurConfig() {
    if (window.lw042GravurConfig || typeof window.lwGravurResolveOption2 !== 'function') {
      return;
    }
    var config = window.lwGravurResolveOption2($('[name="option2"]').attr('data-value') || '');
    if (config) {
      window.lwGravurConfig = config;
      window.lw042GravurConfig = config;
    }
  }

  function usesFrontOnlyPreviewBase() {
    ensureA219GravurConfig();
    var sides = window.lw042GravurConfig && window.lw042GravurConfig.physicalSides;
    return Array.isArray(sides) && sides.length === 1 && sides[0] === 0;
  }

  /* einseitig -> einzel-Bild (ein Armband), beidseitig -> paar-Bild (zwei
     gestapelt). DEV-PROCESS Nr. 3: das paar-Bild darf NIE fuer den einseitigen
     Modus benutzt werden, sonst steht ein leerer zweiter Platz im Rahmen. */
  function getColorPreviewUrl() {
    var set = A219_PREVIEW_IMAGES[getColorKeyFromOption1()] || A219_PREVIEW_IMAGES.silber;
    return usesFrontOnlyPreviewBase() ? set.einzel : set.paar;
  }

  function getSymbolByName(name) {
    if (!name) return null;
    var resolved = normalizeA219StoredSymbol(name);
    var symbols = loadA219Symbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved || symbols[i].text === name) return symbols[i];
    }
    return null;
  }

  function weightedLength(str) {
    if (!str) return 0;
    var total = 0;
    var re = /\(([^)]+)\)/g;
    var last = 0;
    var match;
    while ((match = re.exec(str)) !== null) {
      total += match.index - last;
      total += SYMBOL_COST;
      last = re.lastIndex;
    }
    total += str.length - last;
    return total;
  }

  function getSideIndexFromEl($el) {
    var $side = $el.closest('[class*="product_info_main_"]');
    if (!$side.length) return NaN;
    var match = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getSideLabel(index) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
    var title = $.trim($side.find('.pattles-message-header span').first().text());
    return title || SIDE_LABELS[index] || ('Seite ' + (index + 1));
  }

  function ensurePreviewShell() {
    var $host = $('.up-Fenster-p-personalization-1 .fenster-content-contentin');
    if (!$host.length) return;

    if (!$host.find('.a219-preview-wrap').length) {
      $host.prepend(
        '<div class="a219-preview-wrap">' +
          '<div class="a219-preview-label">Vorschau</div>' +
          '<div class="a219-preview-stage" data-a219-preview-stage>' +
            /* KEIN loading="lazy" — GOTCHAS Nr. 27: das Fenster schiebt sich
               von ausserhalb des Sichtfelds herein, ein lazy Grundbild wird
               dort nie geladen und bleibt auch nach erneutem src-Setzen grau
               (KS017, 2026-09-01). */
            '<img class="a219-preview-base" alt="">' +
            '<div class="a219-preview-layers"></div>' +
          '</div>' +
        '</div>'
      );
    }
  }

  function buildEngravingHtml(raw) {
    if (!raw) return '';
    var html = '';
    var re = /\(([^)]+)\)/g;
    var last = 0;
    var match;
    while ((match = re.exec(raw)) !== null) {
      if (match.index > last) {
        html += esc(raw.substring(last, match.index));
      }
      var sym = getSymbolByName(match[1]);
      if (sym && sym.image) {
        /* Drei Regler haengen an genau diesem <img> — es ist der EINZIGE
           Renderpfad fuer Motive in der Vorschau (bei den grossen Vorlagen
           sind es drei, dort wird regelmaessig einer vergessen):
             D1  Groesse je Motiv          -> height
             D3  Abstand je Schrift×Motiv  -> margin
             G1  Gesamtlage aller Motive   -> translate (G2 skaliert per CSS) */
        var code = sym.code || match[1];
        /* Motivgroesse: Stufenwert (% der Buehne) × Einzelfaktor D1 ×
           Gesamtebene G2. Die Gesamtebene liegt als CSS-Variable drueber
           (--tuner-motiv-scale), damit sie auch dann noch greift, wenn jedes
           Motiv einzeln getunt ist — Ueberlagerung, kein Ersatzwert. */
        var stufe = a219Stufe(raw);
        var tpm = a219Tpm(a219GlobalFont, stufe);
        var stil = 'height:' + (tpm.icon * a219IconFaktor(code)).toFixed(3) + 'cqw;' +
          'margin:0 ' + a219Gap(a219GlobalFont, code, stufe) + 'px;';
        if (A219_TUNE.motivDx || A219_TUNE.motivDy) {
          /* ⚠️ Einheit ist cqw, NICHT %. Bei einem relativ positionierten
             Inline-Bild loest ein prozentuales `top` gegen die Hoehe des
             umgebenden Blocks auf — die haengt hier am Inhalt, ist also auto,
             und das Ergebnis ist `auto`: der Regler fuer die Y-Achse tat
             schlicht nichts (am 2026-08-21 im Zweigdurchlauf aufgefallen,
             die X-Achse funktionierte und verdeckte es). cqw bezieht sich auf
             die Buehne; weil die quadratisch ist, bedeuten beide Achsen
             dasselbe „Prozent der Buehne" wie bei allen anderen Reglern. */
          stil += 'position:relative;left:' + A219_TUNE.motivDx + 'cqw;top:' + A219_TUNE.motivDy + 'cqw;';
        }
        html += '<img src="' + esc(sym.image) + '" alt="' + esc(match[1]) + '" style="' + stil + '">';
      } else {
        html += esc('(' + match[1] + ')');
      }
      last = re.lastIndex;
    }
    if (last < raw.length) {
      html += esc(raw.substring(last));
    }
    return html;
  }

  /* Passt eine Gravurzeile in ihre Breitenkappe ein, statt sie mit "…"
     abzuschneiden. Ladenweit dieselbe Idee wie fitMarkToWidth bei A227 und
     rund einem Dutzend anderer Vorlagen — hier nur in cqw statt in px, damit
     die Zeile responsiv bleibt (px wuerde die Groesse an der Buehnenbreite
     dieses Moments einfrieren).

     Warum A219 das braucht: die Stufen zaehlen ZEICHEN, nicht Breite.
     „MARGARETHE" ist bei gleicher Zeichenzahl 1,9-mal so breit wie
     „Charlotte" (gemessen: 7,06 gegen 3,72 em, scripts/a219/breitenprobe.mjs).
     Ohne Einpassen muesste die Stufe nach dem breitesten denkbaren Namen
     bemessen werden — dann waere die Schrift fuer alle anderen viel zu klein.
     Mit Einpassen darf die Stufe der Laden-Norm folgen, und nur die wirklich
     breiten Faelle werden nachgeregelt.

     ⚠️ Die wahre Breite ist NICHT scrollWidth. Die Zeile traegt
     `text-overflow: ellipsis`, und sobald das greift, ersetzt der Browser
     den Ueberhang durch "…" — scrollWidth meldet danach exakt die Kappe,
     also "passt schon". Genau so hat diese Funktion in ihrer ersten Fassung
     am 2026-09-16 gar nichts getan, und die Zusicherung im Pruefstand hat
     mitgelogen: beide fragten scrollWidth. Aufgefallen ist es erst am
     Musterbild ("MARGARET…" stand da weiterhin).
     Deshalb wird die Kappe fuer die Messung kurz aufgehoben. Das kostet
     einen Reflow je Zeile und ist der einzige Weg, die Breite zu sehen, die
     der Text ohne Kappe haette. */
  function a219WahreBreite(el) {
    var kappe = el.style.maxWidth;
    var floss = el.style.textOverflow;
    el.style.maxWidth = 'none';
    el.style.textOverflow = 'clip';
    var breite = el.getBoundingClientRect().width;
    el.style.maxWidth = kappe;
    el.style.textOverflow = floss;
    return breite;
  }

  /* ⚠️ Genau auf 100 % einpassen reicht NICHT. clientWidth ist gerundet, die
     wahre Breite ist es nicht — bei „passt exakt" schaltet der Browser die
     Ellipse trotzdem ein, und im Bild steht weiter „MARGARET…", waehrend
     jede Messung „passt" sagt. Am 2026-09-16 zweimal darauf hereingefallen,
     beide Male hat erst das Musterbild es gezeigt. Deshalb 2 % Luft und ein
     Abbruch erst, wenn ein ganzes Pixel Platz ist. */
  var A219_EINPASS_LUFT = 0.98;

  /* ⚠️ Zwei Bezugsgroessen, die beide NICHT taugen — beide am 2026-09-16
     durchprobiert:
       clientWidth  — die Zeile ist absolut positioniert, also shrink-to-fit;
                      bei kurzem Text ist das die Breite des Textes selbst.
                      Dagegen verglichen wird auch „A" verkleinert.
       getComputedStyle(el).maxWidth — gibt die Prozentangabe hier
                      unaufgeloest zurueck ("42.77%"); parseFloat macht
                      daraus 42,77 px, und die Schrift schrumpft auf ein
                      Drittel.
     Richtig ist die Kappe in px, und die rechnet der Renderer ohnehin schon
     aus: Feldbreite in Prozent mal Buehnenbreite. Sie wird deshalb
     uebergeben statt hier neu ermittelt. */
  function a219EinpassenAufBreite($zeile, cqw, kappePx) {
    var el = $zeile && $zeile[0];
    if (!el || !cqw || !kappePx) return;
    for (var runde = 0; runde < 3; runde++) {
      var wahr = a219WahreBreite(el);
      if (wahr <= kappePx - 1) return;
      cqw = Math.max(1, cqw * (kappePx / wahr) * A219_EINPASS_LUFT);
      el.style.setProperty('font-size', cqw.toFixed(3) + 'cqw');
    }
  }

  function renderAllPreviewEngravings() {
    var $layers = $('[data-a219-preview-stage] .a219-preview-layers');
    $layers.empty();
    var zu = getActiveSideCount();

    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      if (!$side.length) continue;

      var raw = $.trim(getComposedEngraving(i));
      if (!raw) continue;

      var physicalSide = getPhysicalSideIndex(i);
      var pos = A219_SLOT_ANCHOR[slotForPhysicalSide(physicalSide)] || A219_SLOT_ANCHOR.einzel;
      var sideClass = physicalSide === 1 ? ' a219-preview-text--back' : ' a219-preview-text--front';
      /* max-width kommt je Slot, weil die drei Slots leicht verschieden breit
         gemessen wurden; die Schriftgroesse dagegen je BILDSATZ ueber eine
         CSS-Variable — nur so bleibt der Tuner-Faktor --tuner-block-scale
         wirksam (inline gesetzt wuerde er den Regler aushebeln).

         ⚠️ Die Eigenschaften werden ueber .css() gesetzt und NICHT in ein
         style="..."-Attribut geschrieben. Grund, am 2026-08-21 hier gemessen:
         die Schriftstapel enthalten doppelte Anfuehrungszeichen
         ("Bradley Hand ITC", sans-serif). Roh in ein mit " begrenztes Attribut
         gesetzt, schliessen sie es vorzeitig — die Schriftangabe faellt weg
         und alles danach ebenfalls, die Vorschau lief in Times New Roman.
         Dieselbe Falle steht als Verdacht fuer LW043/KE033 im Aufgabenbuch
         (`lw043-esc-verdacht`); hier ist sie belegt. */
      /* Zwei Ebenen, in dieser Reihenfolge:
           Einzelwert  A219_SLOT_NUDGE[slot]      — nur diese Gravurflaeche
           Gesamtebene A219_TUNE.blockDx/Dy       — alle Flaechen zusammen
         Dasselbe bei der Breitenkappe (Slot-Faktor × Gesamtfaktor). */
      var slot = slotForPhysicalSide(physicalSide);
      var nudge = A219_SLOT_NUDGE[slot] || { x: 0, y: 0 };
      var slotBreite = A219_BREITE_BY_SLOT[slot];
      if (typeof slotBreite !== 'number') slotBreite = 1;
      var kappePct = pos.feldBreite * slotBreite * A219_TUNE.breiteFaktor;
      var buehnePx = $('[data-a219-preview-stage]').width() || 0;
      /* Schriftgroesse: Stufe (Zeichenzahl) × D2 (Schrift) × G4 (Gesamt).
         G4 haengt als CSS-Variable drueber, damit es Ueberlagerung bleibt. */
      var stufeZ = a219Stufe(raw);
      var groesse = a219Tpm(a219GlobalFont, stufeZ).text
        * (A219_TEXT_SIZE_BY_FONT[a219GlobalFont] || 1)
        * A219_TUNE.blockScale;
      /* Drei Ebenen, von innen nach aussen:
           Schrift  a219SchriftNudge(font)  — nur diese Schrift
           Flaeche  A219_SLOT_NUDGE[slot]   — nur diese Gravurflaeche
           Gesamt   A219_TUNE.blockDx/Dy    — alles zusammen */
      var sn = a219SchriftNudge(a219GlobalFont);
      var $zeile = $('<div class="a219-preview-text' + sideClass + '"></div>').css({
        top: (pos.top + sn.y + nudge.y + A219_TUNE.blockDy) + '%',
        left: (pos.left + sn.x + nudge.x + A219_TUNE.blockDx) + '%',
        'font-family': A219_FONT.family,
        'font-size': groesse.toFixed(3) + 'cqw',
        'max-width': kappePct + '%'
      }).html(buildEngravingHtml(raw));
      $layers.append($zeile);
      /* Erst nach dem Einhaengen messbar — vorher hat das Element keine
         Breite. Motivzeilen bleiben unberuehrt: das <img> haengt an cqw,
         nicht an em, und schrumpft mit der Schrift gar nicht mit. */
      if (!$zeile.find('img').length) {
        a219EinpassenAufBreite($zeile, groesse, kappePct / 100 * buehnePx);
      }
    }
  }


  /* ---- Reglerfenster ?a219tuner=1. Panel-Id endet auf -tuner, Griff
     traegt .kt-title: Ziehen und DE/中 kommen von den gemeinsamen Snippets. ---- */
  function a219TunerEnabled() {
    return /a219tuner=1/.test(window.location.search + window.location.hash);
  }

  function a219TunerApply() {
    var b = document.querySelectorAll('[class*="preview-stage"], [class*="preview-layers"]');
    for (var i = 0; i < b.length; i++) {
      b[i].style.setProperty('--tuner-block-scale', A219_TUNE.blockScale);
      b[i].style.setProperty('--tuner-motiv-scale', A219_TUNE.motivScale);
    }
  }

  /* Regler-Fenster. Bis 2026-08-21 war das Panel hier von Hand gebaut; seit
     der zweiten Schrift sind D2 und D3 Pflicht, und die Kontext-Ebene (Regler,
     die der Auswahl im Fenster folgen) gibt es nur in der gemeinsamen Vorlage.
     Handgebaute Panels sind ausserdem seit der Vollausbau-Runde untersagt —
     sie haben vier Klassen Blindgaenger produziert (Escaping, Konfiguration in
     Funktionen, CSS-Reihenfolge, totes Refresh), die die Vorlage strukturell
     ausschliesst. snippets/tuner-vorlage.liquid baut daraus die kanonischen
     Beschriftungen, die scripts/tuner_audit.py prueft. */
  /* Ist die Vorschau ueberhaupt auf dem Schirm? Solange das Fenster
     zugeklappt neben dem Sichtfeld parkt, aendern die Regler zwar Werte, aber
     niemand sieht etwas — das sieht nach kaputten Reglern aus und hat bei
     AS022 einen ganzen Nachmittag gekostet (Commit 8193052). Dann zeigt das
     Panel einen Hinweis statt eines Satzes Scheinregler. */
  function a219VorschauSichtbar() {
    var st = document.querySelector('[data-a219-preview-stage]');
    if (!st) return false;
    var r = st.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function a219OffeneSeitenIndex() {
    var $offen = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"].is-side-open');
    var treffer = /product_info_main_(\d+)/.exec(($offen.first().attr('class') || ''));
    if (treffer) return parseInt(treffer[1], 10);
    return a219OffeneSeite >= 0 ? a219OffeneSeite : 0;
  }

  /* Der Kontext folgt dem, was im FENSTER gerade offen ist: welche Flaeche,
     welche Schrift, welches Motiv, welche Zeichenzahl-Stufe. */
  function a219TunerAuswahl() {
    var idx = a219OffeneSeitenIndex();
    var $side = a219SideEl(idx);
    var physisch = getPhysicalSideIndex(idx);
    var slot = slotForPhysicalSide(physisch);
    var symName = normalizeA219StoredSymbol($side.attr('data-a219-symbol') || '');
    var sym = symName ? getSymbolByName(symName) : null;
    var roh = $.trim(getComposedEngraving(idx));
    var seitenName = physisch === 1 ? 'Rückseite' : 'Vorderseite';
    var stufe = a219Stufe(roh);
    var sichtbar = a219VorschauSichtbar();
    return {
      /* Bei zugeklapptem Fenster ist die Kopfzeile selbst die Anweisung —
         eine Ueberschrift wie „Vorderseite · G02" wuerde behaupten, es gebe
         hier gerade etwas einzustellen. */
      titel: sichtbar
        ? seitenName + ' · ' + a219GlobalFont + ' · ' + stufe + ' Zeichen'
          + (sym ? ' · ' + sym.code : '')
        : '„Jetzt personalisieren" öffnen — die Vorschau ist zugeklappt',
      seite: seitenName,
      slot: slot,
      font: a219GlobalFont,
      stufe: stufe,
      code: sym ? sym.code : '',
      sichtbar: sichtbar
    };
  }

  function a219TplWert(obj, schluessel, grund) {
    return {
      get: function () {
        var v = obj[schluessel];
        return typeof v === 'number' ? v : grund;
      },
      set: function (v) { obj[schluessel] = v; }
    };
  }

  var A219_TUNER_ZUGRIFF = {
    /* --- Gesamtebene: liegt additiv/multiplikativ ueber ALLEM ------------- */
    G3: function () { return [
      { achse: 'x', step: 0.25, get: function () { return A219_TUNE.blockDx; },
        set: function (v) { A219_TUNE.blockDx = v; } },
      { achse: 'y', step: 0.25, get: function () { return A219_TUNE.blockDy; },
        set: function (v) { A219_TUNE.blockDy = v; } }
    ]; },
    G4: function () { return [
      { step: 0.02, get: function () { return A219_TUNE.blockScale; },
        set: function (v) { A219_TUNE.blockScale = v; } }
    ]; },
    G1: function () { return [
      { achse: 'x', step: 0.5, get: function () { return A219_TUNE.motivDx; },
        set: function (v) { A219_TUNE.motivDx = v; } },
      { achse: 'y', step: 0.5, get: function () { return A219_TUNE.motivDy; },
        set: function (v) { A219_TUNE.motivDy = v; } }
    ]; },
    G2: function () { return [
      { step: 0.02, get: function () { return A219_TUNE.motivScale; },
        set: function (v) { A219_TUNE.motivScale = v; } }
    ]; },

    /* --- Kontextebene: folgt der Auswahl im Fenster ----------------------- */
    D2: function (ctx) {
      if (!ctx || !ctx.sichtbar) return [];
      var f = ctx.font;
      /* Der Stufenwert selbst ist der eigentliche Groessenregler; dieser hier
         ist der Faktor darueber, der fuer ALLE Stufen dieser Schrift gilt. */
      return [{ suffix: f, step: 0.02,
        get: function () { return A219_TEXT_SIZE_BY_FONT[f]; },
        set: function (v) { A219_TEXT_SIZE_BY_FONT[f] = v; } }];
    },
    D1: function (ctx) {
      if (!ctx || !ctx.sichtbar) return [];
      if (!ctx.code) return [];
      var c = ctx.code;
      return [{ suffix: c, step: 0.05,
        get: function () { return a219IconFaktor(c); },
        set: function (v) { A219_ICON_SIZE[c] = v; } }];
    },
    /* Seit die Kombi-Karte am 2026-08-23 aus dem Angebot ist, steht bei A219
       nie mehr Text NEBEN einem Motiv: entweder „1 Zeile" (nur Text) oder
       „Nur Motiv" (nur das Bild). Ein Abstand zwischen beiden existiert damit
       nicht mehr. Die Tabelle bleibt fuer Alt-Bestellungen im Renderpfad, aber
       einen Regler dafuer anzubieten waere ein Blindgaenger. */
    D3: function () {
      return 'Seit dem 2026-08-23 gibt es keine Karte mehr, die Text und Motiv '
           + 'zusammen setzt — ein Abstand zwischen beiden kommt nicht mehr vor.';
    },
    /* Text und Motiv stehen bei A219 INLINE in einer Zeile — sie haben keine
       eigenen Koordinaten, die man gegeneinander verschieben koennte. Der
       Abstand zwischen ihnen ist D3. Deshalb ein begruendetes „gibt es hier
       nicht" statt eines toten Reglers. */
    K1: function () { return 'Text und Motiv laufen inline in EINER Zeile — kein eigener Textanker.'; },
    K2: function () { return 'Motiv ist ein Inline-Bild in der Textzeile — Lage folgt dem Text, Abstand siehe D3.'; },

    LB: function (ctx) {
      if (!ctx || !ctx.sichtbar) return [];
      var slot = ctx.slot;
      var w = a219TplWert(A219_BREITE_BY_SLOT, slot, 1);
      return [{ suffix: ctx.seite, step: 0.02, get: w.get, set: w.set }];
    },
    LH: function () { return 'Einzeilige Gravur — die Hoehe folgt der Schriftgroesse (Stufe × D2 × G4), eine eigene Hoehenkappe koennte nur abschneiden.'; }
  };

  /* Produkteigene Zeilen der EINZELEBENE: die Lage dieser einen Gravurflaeche
     und die Groessen der gerade getippten Zeichenzahl-Stufe. */
  function a219TunerKontextExtra(ctx) {
    if (!ctx || !ctx.sichtbar) {
      return [{ h: '„Jetzt personalisieren" öffnen — die Vorschau ist zugeklappt' }];
    }
    var n = A219_SLOT_NUDGE[ctx.slot] || (A219_SLOT_NUDGE[ctx.slot] = { x: 0, y: 0 });
    var t = a219Tpm(ctx.font, ctx.stufe);
    var sn = a219SchriftNudge(ctx.font);
    var zeilen = [
      { h: 'Schrift ' + ctx.font + ' · Lage' },
      { label: 'Text ↔ X %', step: 0.2, get: function () { return sn.x; }, set: function (v) { sn.x = v; } },
      { label: 'Text ↕ Y %', step: 0.2, get: function () { return sn.y; }, set: function (v) { sn.y = v; } },
      { h: ctx.seite + ' · Lage dieser Gravurfläche' },
      { label: 'Block ↔ X %', step: 0.2, get: function () { return n.x; }, set: function (v) { n.x = v; } },
      { label: 'Block ↕ Y %', step: 0.2, get: function () { return n.y; }, set: function (v) { n.y = v; } },
      { h: 'Zeichenzahl-Stufe „' + ctx.stufe + '" · ' + ctx.font },
      { label: 'Text-Größe %', step: 0.1, get: function () { return t.text; }, set: function (v) { t.text = v; } }
    ];
    if (ctx.code) {
      zeilen.push({ label: 'Motiv-Größe %', step: 0.1, get: function () { return t.icon; }, set: function (v) { t.icon = v; } });
      /* „Abstand px" ist hier nicht mehr dabei: er wirkt nur, wenn Text und
         Motiv nebeneinander stehen — diese Karte gibt es nicht mehr. */
    }
    return zeilen;
  }

  function a219TunerExport() {
    return {
      TUNE: A219_TUNE,
      SLOT_NUDGE: A219_SLOT_NUDGE,
      BREITE_BY_SLOT: A219_BREITE_BY_SLOT,
      TPM_BY_FONT: A219_TPM_BY_FONT,
      TEXT_NUDGE_BY_FONT: A219_TEXT_NUDGE_BY_FONT,
      TEXT_SIZE_BY_FONT: A219_TEXT_SIZE_BY_FONT,
      ICON_SIZE: A219_ICON_SIZE,
      TPM_ABSTAND_BY_FONT_ICON: A219_TPM_ABSTAND_BY_FONT_ICON
    };
  }

  function a219BuildTuner() {
    if (!a219TunerEnabled() || document.getElementById('a219-tuner')) return;
    window.VivTuner = window.VivTuner || { q: [], refresh: function () {},
      register: function () { this.q.push(arguments); return { refresh: function () {} }; } };
    if (!window.VivTuner.vollausbau) window.VivTuner.vollausbau =
      function () { this.q.push({ va: arguments }); return { refresh: function () {} }; };
    window.VivTuner.vollausbau('a219', {
      titel: 'A219 Tuner',
      schriften: A219_ALLOWED_FONTS.slice(),
      motive: A219_SYMBOLS_FIXED.map(function (s2) { return s2.code; }),
      layouts: {},
      auswahl: a219TunerAuswahl,
      zugriff: A219_TUNER_ZUGRIFF,
      kontextExtra: a219TunerKontextExtra,
      update: function () { window.a219UpdatePreview(); },
      exportiere: a219TunerExport
    });
  }

  window.a219UpdatePreview = function() {
    a219BuildTuner();
    /* Ohne diese Zeile bleibt die Kontext-Ebene auf dem Stand des ersten
       Aufbaus stehen — der Regler zeigt dann die Werte einer anderen Schrift
       oder eines anderen Motivs an, als gerade gewaehlt ist (A184 hat genau
       daran eine Runde verloren). */
    if (window.VivTuner && window.VivTuner.refresh) window.VivTuner.refresh('a219');
    a219TunerApply();
    ensurePreviewShell();
    var baseUrl = getColorPreviewUrl();
    var $stage = $('[data-a219-preview-stage]');
    $stage.find('.a219-preview-base').attr('src', baseUrl);
    var satz = A219_SLOT_ANCHOR[slotForPhysicalSide(0)];
    if ($stage.length && satz) {
      /* Die Schriftgroesse wird je Gravurzeile inline gesetzt (sie haengt an
         der Zeichenzahl DIESER Zeile), nicht mehr an der Buehne.
         Was hier an der Buehne haengt, ist ihr SEITENVERHAELTNIS: die beiden
         Bildsaetze sind gleich breit, aber verschieden hoch (einzel 692x338,
         paar 692x676). Ohne diese Zeile stuende das Bild in einem der beiden
         Modi in einem zu hohen oder zu flachen Kasten und object-fit
         verkleinerte es — die gemessenen Prozentwerte traefen dann nicht
         mehr. */
      var mass = A219_BUEHNE[satz.bildsatz] || A219_BUEHNE.paar;
      $stage.get(0).style.setProperty('--a219-buehne', mass);
    }
    renderAllPreviewEngravings();
  };

  function parseEngravingValue(raw) {
    var val = raw || '';
    var match = val.match(/\(([^)]+)\)$/);
    if (match && getSymbolByName(match[1])) {
      return {
        text: val.substring(0, val.length - match[0].length),
        symbol: normalizeA219StoredSymbol(match[1])
      };
    }
    return { text: val, symbol: '' };
  }

  function composeEngraving(text, symbol) {
    return (text || '') + (symbol ? '(' + symbol + ')' : '');
  }

  function getSideEngraving(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    var mode = $side.attr('data-a219-mode') || 'zeichen';
    var symbol = normalizeA219StoredSymbol($side.attr('data-a219-symbol') || '');
    var text;

    if (mode === 'zeichen') {
      text = $input.val() || '';
    } else {
      var parsedInput = parseEngravingValue($input.val() || '');
      text = parsedInput.text;
      symbol = normalizeA219StoredSymbol(parsedInput.symbol || symbol);
      $side.attr('data-a219-symbol', symbol);
    }

    return { text: text, symbol: symbol };
  }

  function getComposedEngraving(sideIndex) {
    var parts = getSideEngraving(sideIndex);
    return composeEngraving(parts.text, parts.symbol);
  }

  function captureSideEngraving(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    var mode = $side.attr('data-a219-mode') || 'zeichen';
    var text;
    var symbol = normalizeA219StoredSymbol($side.attr('data-a219-symbol') || '');

    if (mode === 'zeichen') {
      var parsed = parseEngravingValue($input.val() || '');
      text = parsed.text;
      symbol = normalizeA219StoredSymbol(symbol || parsed.symbol);
    } else {
      var composed = parseEngravingValue($input.val() || '');
      text = composed.text;
      symbol = normalizeA219StoredSymbol(symbol || composed.symbol);
    }

    $side.attr('data-a219-symbol', symbol);
    return { text: text, symbol: symbol };
  }

  function syncSymbolGridSelection(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var selected = getSideEngraving(sideIndex).symbol;
    var $grid = $side.find('.a219-symbol-grid');
    $grid.find('button').removeClass('is-active');
    if (selected) {
      $grid.find('button[data-symbol="' + selected + '"]').addClass('is-active');
    }
  }

  function setSymbolSelection(sideIndex, symName) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    if (!$input.length || !symName) return;
    symName = normalizeA219StoredSymbol(symName);

    var parts = captureSideEngraving(sideIndex);
    var composed = composeEngraving(parts.text, symName);
    if (weightedLength(composed) > CHAR_MAX) return;

    $side.attr('data-a219-symbol', symName);

    $input.val(composeEngraving(parts.text, symName));

    updateCharCounter($input, sideIndex);
    syncSymbolGridSelection(sideIndex);
    window.a219UpdatePreview();
  }

  /* Die Anhaenger-Skizze auf der Stilkarte. Gezeichnet wird das ECHTE Teil:
     ein liegendes Fischplaettchen zwischen zwei Kettengliedern — ovaler
     Koerper, Schwanzflosse rechts. K530 malt einen Kreis mit Oese; das hier
     einfach abzuschreiben waere der Fehler, den Yin ausdruecklich verboten hat
     (FOKUS Punkt 9: „坠子外框跟产品实物走").

     Die Proportionen folgen der Messung der Grundbilder: der gravierbare
     Koerper ist rund 74 % der Plaettchenbreite, die Flosse der Rest — deshalb
     endet der Koerper bei x=70 und die Flosse laeuft bis x=84. */
  function a219LayoutIcon(key) {
    var mitte = 41, achse = 28;
    function txt(t, x, y, size) {
      return '<text x="' + x + '" y="' + y + '" font-size="' + size +
             '" text-anchor="middle">' + esc(t) + '</text>';
    }
    function bild(href, x, y, w, h) {
      if (!href) return '';
      var u = esc(href);
      return '<image href="' + u + '" xlink:href="' + u + '" x="' + x + '" y="' + y +
             '" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid meet"/>';
    }
    var herz = '';
    for (var i = 0; i < A219_SYMBOLS_FIXED.length; i++) {
      if (A219_SYMBOLS_FIXED[i].code === 'W02') { herz = A219_SYMBOLS_FIXED[i].image; break; }
    }
    /* EINE durchgehende Kontur statt Koerper + separatem Dreieck: als zwei
       Formen gezeichnet las sich die Flosse wie ein danebenliegender Pfeil,
       nicht wie ein Fisch (am 2026-08-21 im 390px-Bild gesehen). Der Umriss
       folgt dem Foto: runder Kopf links, breiteste Stelle in der Mitte, dann
       eine Taille und eine nach hinten eingezogene Schwanzflosse. */
    var fisch = 'M 13 28 C 13 17 27 11 45 11 C 57 11 64 16 68 22'
              + ' L 84 14 C 78 20 78 36 84 42'
              + ' L 68 34 C 64 40 57 45 45 45 C 27 45 13 39 13 28 Z';
    var body = '';
    if (key === 'nur_motiv') {
      body = bild(herz, mitte - 9, achse - 9, 18, 18);
    } else {
      body = txt('Emma', mitte, achse + 4, 12);
    }
    return '<svg class="a219-layout-icon" viewBox="0 0 100 56" aria-hidden="true">' +
      '<circle class="kli-stroke" cx="6" cy="28" r="4.5"/>' +
      '<path class="kli-stroke" d="' + fisch + '"/>' +
      '<circle class="kli-stroke" cx="93" cy="28" r="4.5"/>' +
      body +
    '</svg>';
  }

  /* Die Kartenreihe. Die Faltregel des Massstabs steht hier im Code, nicht
     im Kopf: `A219_LAYOUTS.length > 3` — am Handy zeigt K530 dann drei
     Karten und legt den Rest hinter „Weitere Gravur-Arten". A219 bietet
     derzeit ZWEI Gravur-Arten an, die Regel sagt also von selbst „nicht
     falten". Bis zum 2026-08-23 fehlte der Mechanismus ganz und die Entscheidung
     stand nur als Kommentar da — kaeme je eine dritte oder vierte Karte dazu,
     haette niemand gemerkt, dass sie am Handy aus der Reihe faellt. */
  function buildLayoutRow(sideIndex) {
    var faltbar = A219_LAYOUTS.length > 3;
    var h = '<div class="a219-layout-row' + (faltbar ? ' is-collapsed' : '') +
            '" data-side="' + sideIndex + '">';
    for (var i = 0; i < A219_LAYOUTS.length; i++) {
      var l = A219_LAYOUTS[i];
      h += '<button type="button" class="a219-layout-option' + (i === 0 ? ' is-active' : '') +
             (faltbar && i < 3 ? ' a219-chip-visible' : '') +
             '" data-key="' + esc(l.key) + '">' +
             a219LayoutIcon(l.key) +
             '<span class="a219-layout-name">' + esc(l.label) + '</span>' +
             '<span class="a219-layout-sub">' + esc(l.sub) + '</span>' +
           '</button>';
    }
    h += '</div>';
    if (faltbar) {
      h += '<button type="button" class="a219-layout-more">Weitere Gravur-Arten ('
         + (A219_LAYOUTS.length - 3) + ') &#9662;</button>';
    }
    return h;
  }

  /* Zugeklappte Stilliste nachziehen: aktive Karte + Auffueller bis drei
     sichtbar, Knopftext zaehlt, was noch im Fach liegt. Wortgleich zu
     k530SyncLayoutCollapse. */
  function a219SyncLayoutCollapse($scope) {
    $scope.find('.a219-layout-row').addBack('.a219-layout-row').each(function() {
      var $row = $(this);
      var $more = $row.next('.a219-layout-more');
      if (!$more.length) return;
      var $chips = $row.find('.a219-layout-option');
      if (!$row.hasClass('is-collapsed')) {
        $more.text('Weniger anzeigen \u25B4');
        return;
      }
      $more.text('Weitere Gravur-Arten (' + Math.max($chips.length - 3, 0) + ') \u25BE');
      $chips.removeClass('a219-chip-visible');
      var $active = $chips.filter('.is-active').first();
      $active.addClass('a219-chip-visible');
      $chips.not($active).slice(0, $active.length ? 2 : 3).addClass('a219-chip-visible');
    });
  }

  function buildSymbolGrid(sideIndex) {
    var symbols = loadA219Symbols();
    var selected = getSideEngraving(sideIndex).symbol;
    var html = '<div class="a219-symbol-grid" data-side="' + sideIndex + '">';
    for (var i = 0; i < symbols.length; i++) {
      var sym = symbols[i];
      var activeAttr = sym.text === selected ? ' class="is-active"' : '';
      html += '<button type="button"' + activeAttr + ' data-symbol="' + esc(sym.text) + '" title="' + esc(sym.text) + '">' +
        '<img src="' + esc(sym.image) + '" alt="' + esc(sym.text) + '" loading="lazy">' +
        '<span class="a219-symbol-label">' + esc(sym.text) + '</span>' +
      '</button>';
    }
    html += '</div>';
    return html;
  }

  /* Heisst weiter „fixed", weil jede Aufrufstelle unveraendert bleiben soll —
     gesetzt wird jetzt die GEWAEHLTE Schrift statt einer Konstanten. */
  function applyFixedFont($input) {
    $input.css('font-family', A219_FONT.family);
    $input.attr('data-font-family', A219_FONT.name);
  }

  /* ==================================================================
     KONTEXT-SCHRIFTART  (docs/KONTEXT-SCHRIFTART-STANDARD.md)

     Regeln, die hier eins zu eins gelten:
       §1.2  Die Probe zeigt das KUERZEL der Schrift, nie die Kundeneingabe.
       §1.4  Eine Schrift fuer das ganze Armband — global, nicht je Seite.
       §1.4b Nur die erste Textstelle ist waehlbar; die zweite spiegelt sie
             und braucht zwei Klicks, bis sie zur waehlbaren Zeile springt.
       §3.1  Der Wahrheitswert wird nie geloescht, nur gespiegelt.
     ================================================================== */
  function buildFontZeile(sideIndex) {
    var h = '<div class="a219-font-zeile a219-font-zeile--zu" data-side="' + sideIndex + '">' +
      '<button type="button" class="a219-font-kopf">' +
        '<span class="a219-font-titel">Schriftart</span>' +
        '<span class="a219-font-probe" data-value=""></span>' +
        '<span class="a219-font-chev" aria-hidden="true">▾</span>' +
      '</button>' +
      '<p class="a219-font-hinweis">Eine Schrift für das ganze Armband — zum Ändern tippen.</p>' +
      '<div class="a219-font-grid">';
    for (var i = 0; i < A219_FONTS.length; i++) {
      var f = A219_FONTS[i];
      h += '<button type="button" class="a219-font-item" data-font="' + esc(f.code) + '">' +
             '<span class="a219-font-probe" data-value="' + esc(f.code) + '"' +
               ' style="font-family:' + f.family + '">' + esc(f.code) + '</span>' +
             '<span class="a219-font-code">' + esc(f.code) + '</span>' +
           '</button>';
    }
    return h + '</div></div>';
  }

  /* Spiegelt den Wahrheitswert in JEDE Zeile: aktive Karte, Kopf-Probe,
     Rolle (waehlbar / Spiegel). Wird aus applyGlobalFont gerufen, also aus
     jedem Pfad, der das Fenster neu aufbaut. */
  function syncPanelFontUI() {
    var font = a219GlobalFont;
    var family = a219FontFamily(font);
    var $zeilen = $('.up-Fenster-p-personalization-1 .a219-font-zeile');
    $zeilen.each(function(i) {
      var $z = $(this);
      /* Die Rolle wird bei JEDEM Lauf neu vergeben: welche Seite die erste
         ist, aendert sich mit Variante und Aufbau. */
      var spiegel = i > 0;
      $z.toggleClass('a219-font-zeile--spiegel', spiegel);
      if (spiegel) {
        $z.removeClass('is-open');
        /* Schon einmal angetippte Spiegelzeilen bleiben aufgedeckt. */
        if (typeof $z.attr('data-beruehrt') === 'undefined') {
          $z.addClass('a219-font-zeile--zu');
        }
      } else {
        $z.removeClass('a219-font-zeile--zu').removeAttr('data-beruehrt');
      }
      var $kopfProbe = $z.find('.a219-font-kopf .a219-font-probe');
      $kopfProbe.attr('data-value', font).text(font).css('font-family', family);
      $z.find('.a219-font-item').each(function() {
        var $b = $(this);
        $b.toggleClass('is-active', $b.attr('data-font') === font);
      });
    });
  }

  /* Springt zur einzigen waehlbaren Schriftzeile: falls deren Seite zugeklappt
     ist, erst aufklappen, dann die Liste oeffnen und hinscrollen. */
  function a219SpringZurSchriftwahl() {
    var $ziel = $('.up-Fenster-p-personalization-1 .a219-font-zeile')
      .not('.a219-font-zeile--spiegel').first();
    if (!$ziel.length) return;
    var $seite = $ziel.closest('[class*="product_info_main_"]');
    var treffer = /product_info_main_(\d+)/.exec($seite.attr('class') || '');
    if (treffer && !$seite.hasClass('is-side-open')) {
      a219OpenSide(parseInt(treffer[1], 10), false);
    }
    $ziel.addClass('is-open');
    a219ScrollSideIntoView($seite);
  }

  function applyGlobalFont(font) {
    for (var i = 0; i < A219_FONTS.length; i++) {
      if (A219_FONTS[i].code === font) { a219GlobalFont = font; break; }
    }
    syncPanelFontUI();
    $('.up-Fenster-p-personalization-1 .number-header-textarea').each(function() {
      applyFixedFont($(this));
    });
    window.a219UpdatePreview();
  }

  function updateCharCounter($input, sideIndex) {
    if (isNaN(sideIndex)) {
      sideIndex = getSideIndexFromEl($input);
    }
    var composed = isNaN(sideIndex) ? ($input.val() || '') : getComposedEngraving(sideIndex);
    var len = weightedLength(composed);
    var $words = $input.siblings('.number-header-words');
    $words.find('.number-1').text(len);
    $words.find('.wordsNum_v1').text(CHAR_MAX);
    if (composed) {
      $input.siblings('.number-header-icon').css('display', 'block');
    } else {
      $input.siblings('.number-header-icon').css('display', 'none');
    }
  }

  function setSideMode(sideIndex, mode) {
    sideModes[sideIndex] = mode;
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var parts = captureSideEngraving(sideIndex);
    $side.attr('data-a219-mode', mode);

    var $textareaBlock = $side.find('.p-w-plattchen-list-number-header');
    var $tabParameter = $side.find('.pattles-tab-parameter');
    var $input = $side.find('.text_class_' + sideIndex);

    $side.find('.a219-side-error').hide();
    $side.removeClass('has-error');

    if (mode === 'zeichen') {
      $tabParameter.show();
      $textareaBlock.show();
      $side.find('.font_main').hide();
      $side.find('.image_main').hide();
      $side.find('.a219-symbol-grid').hide();
      $side.attr('data-type', 'text');
      $input.val(parts.text);
      $input.prop('readonly', false);
      applyFixedFont($input);
    } else if (mode === 'symbol') {
      $tabParameter.show();
      $textareaBlock.show();
      $side.find('.font_main').hide();
      $side.find('.image_main').hide();
      var symbols = loadA219Symbols();
      var $grid = $side.find('.a219-symbol-grid');
      if (!$grid.length || $grid.find('button').length !== symbols.length) {
        $grid.remove();
        $side.find('.p-w-plattchen-list-number-header').after(buildSymbolGrid(sideIndex));
      } else {
        syncSymbolGridSelection(sideIndex);
      }
      $side.find('.a219-symbol-grid').show();
      $side.attr('data-type', 'image');
      $input.val(composeEngraving(parts.text, parts.symbol));
      $input.prop('readonly', false);
      applyFixedFont($input);
      syncSymbolGridSelection(sideIndex);
    }

    updateCharCounter($input, sideIndex);
    window.a219UpdatePreview();
  }

  /* Die Gravur-Art. Sie ist die Bedienoberflaeche ueber den zwei internen
     Modi: „1 Zeile" und „Text + Motiv" laufen beide auf demselben Eingabefeld,
     „Nur Motiv" blendet es aus — sonst koennte die Kundin Text eintippen, den
     die gewaehlte Art gar nicht vorsieht, und die Bestell-Eigenschaft hiesse
     hinterher etwas anderes als die Karte. */
  function setSideLayout(sideIndex, key) {
    var $side = a219SideEl(sideIndex);
    if (!$side.length) return;
    $side.attr('data-a219-layout', key);
    $side.find('.a219-layout-option').removeClass('is-active');
    $side.find('.a219-layout-option[data-key="' + key + '"]').addClass('is-active');

    if (key === '1_zeile') {
      /* Kein Motiv in dieser Art — das gemerkte loeschen, sonst taucht es
         beim naechsten Wechsel wieder auf. */
      $side.attr('data-a219-symbol', '');
      setSideMode(sideIndex, 'zeichen');
    } else if (key === 'nur_motiv') {
      setSideMode(sideIndex, 'symbol');
      var $eingabe = $side.find('.text_class_' + sideIndex);
      var teile = parseEngravingValue($eingabe.val() || '');
      $eingabe.val(composeEngraving('', teile.symbol));
      $side.find('.p-w-plattchen-list-number-header').hide();
      updateCharCounter($eingabe, sideIndex);
      window.a219UpdatePreview();
    } else {
      setSideMode(sideIndex, 'symbol');
      $side.find('.p-w-plattchen-list-number-header').show();
    }
  }

  function bindSideEvents() {
    var $popup = $('.up-Fenster-p-personalization-1');

    /* [3] Kopfzeile klappt die Seite auf. Delegiert, weil das Popup neu
       aufgebaut wird; ein Klick auf die bereits offene Seite tut nichts
       (sonst waere gar keine Seite mehr offen). */
    $popup.off('click.a219Side', '.a219-side--klappbar > .pattles-message-header')
      .on('click.a219Side', '.a219-side--klappbar > .pattles-message-header', function() {
        var $side = $(this).parent();
        if ($side.hasClass('is-side-open')) return;
        var treffer = /product_info_main_(\d+)/.exec($side.attr('class') || '');
        if (!treffer) return;
        a219OpenSide(parseInt(treffer[1], 10), true);
      });

    /* --- Kontext-Schriftart ------------------------------------------------
       Kopf der WAEHLBAREN Zeile klappt die Liste auf. Die Spiegelzeile klappt
       sich nie selbst auf: erster Klick deckt nur den Hinweis auf, zweiter
       (oder ein Klick auf den Hinweis) springt zur waehlbaren Zeile. */
    $popup.off('click.a219Font', '.a219-font-kopf')
      .on('click.a219Font', '.a219-font-kopf', function() {
        var $z = $(this).closest('.a219-font-zeile');
        if (!$z.hasClass('a219-font-zeile--spiegel')) {
          $z.toggleClass('is-open');
          return;
        }
        if ($z.hasClass('a219-font-zeile--zu')) {
          $z.removeClass('a219-font-zeile--zu').attr('data-beruehrt', '1');
          return;
        }
        a219SpringZurSchriftwahl();
      });

    $popup.off('click.a219FontHinweis', '.a219-font-hinweis')
      .on('click.a219FontHinweis', '.a219-font-hinweis', function() {
        a219SpringZurSchriftwahl();
      });

    $popup.off('click.a219FontWahl', '.a219-font-item')
      .on('click.a219FontWahl', '.a219-font-item', function() {
        var font = $(this).attr('data-font');
        if (!font) return;
        applyGlobalFont(font);
        /* Nach der Wahl klappt die Liste zu — Standard §1.3. */
        $(this).closest('.a219-font-zeile').removeClass('is-open');
      });

    $popup.off('click.a219Layout', '.a219-layout-option')
      .on('click.a219Layout', '.a219-layout-option', function() {
        var idx = getSideIndexFromEl($(this));
        if (isNaN(idx)) return;
        setSideLayout(idx, $(this).attr('data-key'));
        /* Nach der Wahl klappt die Liste wieder zu (nur am Handy sichtbar),
           damit die Vorschau oben im Blick bleibt — wie im Massstab. */
        var $row = $(this).closest('.a219-layout-row');
        if ($row.next('.a219-layout-more').length) {
          $row.addClass('is-collapsed');
          a219SyncLayoutCollapse($row.parent());
        }
      });

    $popup.off('click.a219LayoutMehr', '.a219-layout-more')
      .on('click.a219LayoutMehr', '.a219-layout-more', function() {
        $(this).prev('.a219-layout-row').toggleClass('is-collapsed');
        a219SyncLayoutCollapse($(this).parent());
      });

    $popup.off('click.a219Symbol', '.a219-symbol-grid button').on('click.a219Symbol', '.a219-symbol-grid button', function() {
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      var symName = $(this).data('symbol');
      if (!symName) return;
      setSymbolSelection(idx, symName);
    });

    $popup.find('.number-header-textarea').off('input.a219 propertychange.a219').on('input.a219 propertychange.a219', function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      if (isNaN(idx)) return;
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + idx);
      var mode = $side.attr('data-a219-mode') || 'zeichen';

      if (mode === 'zeichen') {
        var text = $input.val() || '';
        var symbol = normalizeA219StoredSymbol($side.attr('data-a219-symbol') || '');
        while (weightedLength(composeEngraving(text, symbol)) > CHAR_MAX && text.length) {
          text = text.slice(0, -1);
        }
        $input.val(text);
      } else {
        var val = $input.val() || '';
        while (weightedLength(val) > CHAR_MAX && val.length) {
          val = val.slice(0, -1);
        }
        var parsed = parseEngravingValue(val);
        $side.attr('data-a219-symbol', normalizeA219StoredSymbol(parsed.symbol || ''));
        $input.val(val);
        syncSymbolGridSelection(idx);
      }

      updateCharCounter($input, idx);
      window.a219UpdatePreview();
    });

    $popup.find('.number-header-icon').off('click.a219').on('click.a219', function() {
      var $input = $(this).siblings('.number-header-textarea');
      var idx = getSideIndexFromEl($input);
      if (isNaN(idx)) return;
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + idx);
      $side.attr('data-a219-symbol', '');
      $input.val('');
      updateCharCounter($input, idx);
      syncSymbolGridSelection(idx);
      $(this).css('display', 'none');
      window.a219UpdatePreview();
    });
  }

  function setupSide(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (!$side.length) return;

    $side.find('.pattles-tab-header').hide();

    if (!$side.find('.a219-layout-row').length) {
      $side.find('.pattles-message-header').after(
        buildLayoutRow(sideIndex) +
        '<p class="a219-side-error">Bitte gib einen Gravurtext ein oder wähle ein Symbol.</p>');
    }
    /* Der alte Zwei-Tab-Umschalter ist ersatzlos weg. Falls ein Neuaufbau des
       Popups noch einen stehen laesst, hier wegraeumen — sonst stuenden beide
       Bedienformen uebereinander. */
    $side.find('.a219-mode-switch').remove();

    /* Die Schriftzeile sitzt zwischen Modusschalter und Eingabe — im Panel
       der Textstelle, nicht als Dauerblock oben (Standard §1.1). */
    if (!$side.find('.a219-font-zeile').length) {
      /* Hinter den GESAMTEN Kartenblock, nicht hinter die Kartenreihe: gibt es
         den Aufklapp-Knopf (ab vier Gravur-Arten), muss er der direkte
         Nachbar der Reihe bleiben — `a219SyncLayoutCollapse` und der
         Klick-Handler finden ihn ueber `.next()`. Schoebe sich die
         Schriftzeile dazwischen, waeren die eingeklappten Karten am Handy
         unerreichbar (gemessen mit vier Karten am 2026-08-23). */
      var $nachKarten = $side.find('.a219-layout-more').first();
      if (!$nachKarten.length) $nachKarten = $side.find('.a219-layout-row').first();
      $nachKarten.after(buildFontZeile(sideIndex));
    }

    var $input = $side.find('.text_class_' + sideIndex);
    if (typeof $side.attr('data-a219-symbol') === 'undefined') {
      var initial = parseEngravingValue($input.val() || '');
      $side.attr('data-a219-symbol', normalizeA219StoredSymbol(initial.symbol));
    }
    applyFixedFont($input);
    $input.attr('placeholder', 'Gib deinen Gravurtext ein.');
    $input.attr('maxlength', 40);

    var $words = $side.find('.number-header-words');
    if ($words.length) {
      $words.html('<span class="number-1">0</span> / <span class="wordsNum_v1">' + CHAR_MAX + '</span>');
    }

    /* Die Art aus dem vorhandenen Inhalt ableiten — bei einem Neuaufbau des
       Popups (Variantenwechsel, Wiederherstellen) steht der Text schon da. */
    var vorhanden = parseEngravingValue($input.val() || '');
    var start = $side.attr('data-a219-layout');
    if (!start) {
      /* Ein Altbestand mit Text UND Motiv (aus der Zeit, als es die Kombi-Karte
         noch gab) landet auf „Nur Motiv" — das ist die Karte, die sein Motiv
         erhaelt. Der Text bleibt im Feld gespeichert, geht also nicht verloren,
         solange sie nichts anfasst. */
      if (vorhanden.symbol) start = 'nur_motiv';
      else start = '1_zeile';
    }
    setSideLayout(sideIndex, start);
  }

  /* ==================================================================
     FOKUS — K530-Anzeigestandard. Uebernommen von LW042 (dort seit
     2026-08-15, gleiche Bauart und gleiche Gravurlogik). Nur Darstellung
     und Bedienung; die Bestell-Eigenschaften bleiben unveraendert.
     ================================================================== */

  function a219SideEl(index) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
  }

  function a219AlleSeiten() {
    return $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
  }

  function a219ScrollEl() {
    return $('.up-Fenster-p-personalization-1')
      .find('.fenster-content-inner, .fenster-content-contentin').get(0);
  }

  function a219ScrollPolster(scrollEl) {
    return parseFloat((window.getComputedStyle(scrollEl) || {}).paddingTop) || 0;
  }

  /* Der Versatz zieht die angepinnte Vorschau ab, damit der Seitenkopf nicht
     dahinter verschwindet — am Desktop ist sie nicht sticky, dann ist der
     Versatz null.
     📌 Offene Frage aus GOTCHAS Nr. 20: live scrollt die Popup-SCHALE
     (.up-Fenster-p-personalization), nicht .fenster-content-inner. Hier steht
     bewusst dieselbe Fassung wie bei LW042, damit beide gemeinsam korrigiert
     werden (Aufgabe ausweichen-spruenge-ins-leere) und nicht zwei Varianten
     nebeneinander stehen. */
  function a219ScrollSideIntoView($side) {
    var scrollEl = a219ScrollEl();
    if (!scrollEl || !$side || !$side.length) return;
    var versatz = 8;
    var $pv = $('.a219-preview-wrap').first();
    if ($pv.length && $pv.css('position') === 'sticky') {
      versatz += ($pv.outerHeight() || 0) + a219ScrollPolster(scrollEl);
    }
    var top = $side[0].getBoundingClientRect().top
      - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - versatz;
    scrollEl.scrollTop = Math.max(0, top);
  }

  /* [3] Seiten-Akkordeon: nur bei beidseitiger Gravur, dann ist immer genau
     eine Seite offen. Der Zustand ueberlebt den Neuaufbau des Popups. */
  var a219OffeneSeite = 0;

  function a219EnsureChevron($side) {
    var $head = $side.children('.pattles-message-header');
    /* Der Titel-span bleibt das ERSTE Kind — getSideLabel liest ihn per
       .first(), das Chevron haengt dahinter. */
    if ($head.length && !$head.children('.a219-side-chev').length) {
      $head.append('<span class="a219-side-chev" aria-hidden="true">▾</span>');
    }
  }

  function a219OpenSide(index, scrollen) {
    var $sides = a219AlleSeiten();
    if (!$sides.filter('.a219-side--klappbar').length) return;
    a219OffeneSeite = index;
    $sides.removeClass('is-side-open');
    var $ziel = a219SideEl(index).addClass('is-side-open');
    if (scrollen) a219ScrollSideIntoView($ziel);
  }

  function a219ApplyAkkordeon(zu) {
    var $sides = a219AlleSeiten();
    if (zu < 2) {
      /* Einseitig: kein Akkordeon — die Klasse wegnehmen, damit die
         Zuklapp-Regeln nichts verstecken koennen. */
      $sides.removeClass('a219-side--klappbar').addClass('is-side-open');
      return;
    }
    $sides.addClass('a219-side--klappbar').each(function() {
      a219EnsureChevron($(this));
    });
    var ziel = (a219OffeneSeite >= 0 && a219OffeneSeite < zu) ? a219OffeneSeite : 0;
    $sides.removeClass('is-side-open');
    a219SideEl(ziel).addClass('is-side-open');
    a219OffeneSeite = ziel;
  }

  /* Vor dem Fenster muss die Bandfarbe stehen.
     ⚠️ Das Feld heisst im Laden `bandfarbe` — der Name kommt aus dem
     Blocktitel der Vorlage. `properies` ist NICHT der allgemeine Name fuer
     dieses Feld, sondern der des Geburtsstein-Pickers; bei A219 existiert er
     nicht. Wer hier nur `properies` liest, findet nie etwas und sperrt das
     Fenster zu (2026-09-15 genau so passiert, siehe Kopfkommentar und GOTCHAS Nr. 36).
     Beide Namen werden gelesen, damit die Zeile auch dann noch stimmt, wenn
     der Blocktitel in der Vorlage einmal umbenannt wird. */
  window.a219ValidateBeforeOpen = function() {
    var $wahl = $('[name="bandfarbe"]:checked');
    if (!$wahl.length) $wahl = $('[name="properies"]:checked');
    var value = ($wahl.attr('data-value') || $wahl.val() || '').trim();
    if (!value) {
      alert('Bitte wähle zuerst eine Bandfarbe aus.');
      return false;
    }
    return true;
  };

  window.a219AfterUpdateSize = function(zu) {
    if (window.lw042GravurConfig && window.lw042GravurConfig.physicalSides) {
      setPhysicalSideMap(window.lw042GravurConfig.physicalSides);
    } else {
      var parsedZu = parseInt(zu, 10) || 0;
      var defaultMap = [];
      for (var mapIndex = 0; mapIndex < parsedZu; mapIndex++) defaultMap.push(mapIndex);
      setPhysicalSideMap(defaultMap);
    }

    zu = parseInt(zu, 10) || 0;
    if (zu < 1) {
      return;
    }
    zu = Math.min(zu, 2);
    previewSideCount = zu;
    ensurePreviewShell();
    for (var i = 0; i < zu; i++) {
      setupSide(i);
    }
    bindSideEvents();
    a219ApplyAkkordeon(zu);
    /* Rollen (waehlbar / Spiegel) haengen an der DOM-Reihenfolge und werden
       deshalb bei JEDEM Aufbau neu vergeben — nicht einmalig beim Einbau. */
    syncPanelFontUI();
    window.a219UpdatePreview();
  };

  window.a219OnPopupOpen = function() {
    a219SymbolsCache = null;
    /* von event.liquid gesetzt (dort 'if (isLw042Product)'), genau wie
       window.lw042GravurConfig ein Schreib-von-drueben-Slot — deshalb hier
       unter dem lw042-Namen gelesen und nicht aliasiert. */
    if (window.lw042RefreshPopupSides) {
      window.lw042RefreshPopupSides();
    }
    ensurePreviewShell();
    var $sides = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
    previewSideCount = $sides.length || previewSideCount;
    if (window.a219AfterUpdateSize) {
      a219AfterUpdateSize(previewSideCount);
    } else {
      bindSideEvents();
      window.a219UpdatePreview();
    }
  };

  window.a219OnPopupClose = function() {
    $('.product-info--a219 [class*="product_info_main_"]').removeClass('has-error');
  };

  window.a219ValidateSides = function(zu) {
    zu = Math.min(Math.max(parseInt(zu, 10) || 1, 1), 2);
    var valid = true;
    var ersteFehlerSeite = -1;
    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      $side.removeClass('has-error');
      $side.find('.a219-side-error').hide();
      $side.find('.text_class_' + i).parent().removeClass('error');

      var composed = $.trim(getComposedEngraving(i));
      if (!composed) {
        valid = false;
        $side.addClass('has-error');
        $side.find('.text_class_' + i).parent().addClass('error');
        $side.find('.a219-side-error').show();
        if (ersteFehlerSeite < 0) ersteFehlerSeite = i;
      }
    }
    if (!valid) {
      /* [6] Fokus-Regel: nur die ERSTE fehlerhafte Seite aufklappen und
         anspringen. Weitere tragen am zugeklappten Kopf ein rotes „!" und
         kommen beim naechsten Klick der Reihe nach dran. */
      if (ersteFehlerSeite >= 0) a219OpenSide(ersteFehlerSeite, false);
      alert('Bitte fülle die Gravur für jede Seite aus.');
      if (ersteFehlerSeite >= 0) a219ScrollSideIntoView(a219SideEl(ersteFehlerSeite));
    }
    return valid;
  };

  window.a219AppendSideProperties = function(properies_arr, zu, popup_title) {
    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }

      var engraving = getSideEngraving(i);
      var composed = composeEngraving(engraving.text, engraving.symbol);
      if (!$.trim(composed)) continue;

      var orderRow = symbolOrderRow(title, engraving, true);
      if ($.trim(orderRow.value)) properies_arr.push([orderRow.name, orderRow.value]);
      if (engraving.text) properies_arr.push([title + ' Font', A219_FONT.name]);
    }
  };

  window.a219ConfirmHtml = function(zu, popup_title) {
    var html = '';
    var template = $('#form_message_option2').html() || $('#form_message_option').html();
    if (!template) return '';

    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }

      var engraving = getSideEngraving(i);
      var composed = composeEngraving(engraving.text, engraving.symbol);
      if (!$.trim(composed)) continue;

      var confirmRow = symbolOrderRow(title, engraving, false);
      if ($.trim(confirmRow.value)) {
        html += template.replaceAll('{option_name}', confirmRow.name).replaceAll('{option_value}', confirmRow.value);
      }
      if (engraving.text) {
        html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', A219_FONT.name);
      }
    }
    if (html) {
      /* [7] Platzhalter fuer den Vorschau-Streifen — befuellt wird er per
         DOM-Klon NACH dem Einhaengen der Bestaetigungsseite
         (a219FillConfirmVorschau). */
      html = '<div class="a219-confirm-vorschau" aria-hidden="true"></div>' + html;
    }
    return html;
  };

  /* [7] Vorschau-Streifen auf der Bestaetigungsseite: klont die live
     gerenderte Buehne aus dem Popup — gleiche Seite, gleiche Styles, gleiche
     Schrift, also pixelgleich zum Popup.
     ⚠️ Beim Bestaetigen ist das Popup ZU, die Buehne also 0 breit — und weil
     die Schriftgroesse an einer Container-Query (cqw) haengt, kaeme ein Klon
     in diesem Zustand verzerrt heraus. Darum vorher unsichtbar messbar machen
     (fixed, -9999px), frisch rendern, klonen, alles zurueckdrehen. */
  function a219FillConfirmVorschau() {
    var $ziel = $('.message-confirm-item-2 .a219-confirm-vorschau').last();
    if (!$ziel.length || $ziel.children().length) return;
    var $popup = $('.up-Fenster-p-personalization-1');
    if (!$popup.length) return;

    var altStyle = $popup.attr('style') || '';
    $popup.css({ display: 'block', visibility: 'hidden', position: 'fixed', left: '-9999px', top: '0' });
    window.a219UpdatePreview();

    var $stage = $('[data-a219-preview-stage]').first();
    var sw = $stage.length ? $stage[0].offsetWidth : 0;
    var sh = $stage.length ? $stage[0].offsetHeight : 0;
    if (sw && sh) {
      /* A219 hat genau EINE Buehne: bei beidseitiger Gravur zeigt das
         Grundbild beide Armbaender uebereinander, oben Vorderseite, unten
         Rueckseite. Also eine Kachel, so breit wie die Spalte zulaesst,
         hoechstens 130 px (derselbe Deckel wie bei LW042). */
      var ZIEL_B = Math.max(64, Math.min(130, $ziel.width() || 320));
      var f = ZIEL_B / sw;
      var $clip = $('<div class="a219-cv-clip"></div>')
        .css({ width: ZIEL_B + 'px', height: Math.ceil(sh * f) + 'px', overflow: 'hidden' });
      var $scale = $('<div class="a219-cv-scale"></div>')
        .css({ width: sw + 'px', transform: 'scale(' + f + ')', 'transform-origin': 'top left' });
      $scale.append($stage.clone());
      $clip.append($scale);
      var name = previewSideCount > 1
        ? 'VS · RS'
        : (getPhysicalSideIndex(0) === 1 ? 'RS' : 'VS');
      $ziel.append($('<div class="a219-cv-item"></div>')
        .css('width', ZIEL_B + 'px')
        .append($clip)
        .append('<div class="a219-cv-name">' + esc(name) + '</div>'));
    }

    $popup.attr('style', altStyle);
  }

  window.a219EnhanceConfirmOptions = function() {
    /* laeuft im Event-File VOR dem Einhaengen von .message-confirm-item-2 —
       der Handler dort ist synchron, also reicht ein Tick Verzoegerung.
       Der Zweig dafuer existiert bereits: product-info-event.liquid ruft in
       der is_lw042_product-Kette lw042EnhanceConfirmOptions, und dieses Gate
       ist auch fuer '2026-fisch-a219' wahr. Kein Zuwachs in event.liquid. */
    setTimeout(a219FillConfirmVorschau, 0);
  };

  $(document).on('change.a219Color', '[name="option1"]', function() {
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) {
      window.a219UpdatePreview();
    }
  });

  $(document).on('change.a219GravurOption', '[name="option2"]', function() {
    window.lw042GravurConfig = null;
    window.lwGravurConfig = null;
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) {
      window.a219UpdatePreview();
    }
  });

  /* ================================================================
   *  BRUECKE ZUR event.liquid-VERDRAHTUNG  ("Null-Kopie", Muster KE029)
   * ================================================================
   *  product-info-event.liquid ruft an ueber 20 Stellen window.lw042*
   *  auf. Statt diese 20 Zweige fuer A219 zu duplizieren — was die
   *  Datei fuer JEDE Produktseite im Shop schwerer machen wuerde
   *  (GOTCHAS Nr. 15, SOP Phase 2.4) — laeuft A219 auf demselben
   *  Gate: is_lw042_product ist auch fuer '2026-fisch-a219' wahr.
   *  Hier werden die a219-Funktionen unter den lw042-Namen
   *  veroeffentlicht, damit die bestehenden Zweige greifen.
   *
   *  Kollisionsfrei, weil nie beide Snippets auf derselben Seite
   *  aktiv sind: jedes ist auf sein eigenes template_suffix begrenzt
   *  ('2-1-7-gs-szj' bzw. '2026-fisch-a219').
   *
   *  Zwei Namen sind bewusst NICHT aliasiert, weil event.liquid dorthin
   *  SCHREIBT und das Snippet nur LIEST — ein Funktionsalias wuerde die
   *  spaetere Zuweisung nicht mitbekommen. Beide werden im Snippet direkt
   *  unter dem lw042-Namen benutzt:
   *    window.lw042GravurConfig        (event.liquid Zeile ~2163)
   *    window.lw042RefreshPopupSides   (event.liquid Zeile ~5787)
   *
   *  Wer hier einen Namen ergaenzt, muss ihn auch in
   *  scripts/check-a219-bridge.py eintragen — das Skript vergleicht
   *  diese Liste gegen die von event.liquid tatsaechlich gerufenen.
   */
  window.lw042ValidateBeforeOpen   = window.a219ValidateBeforeOpen;
  window.lw042AfterUpdateSize      = window.a219AfterUpdateSize;
  window.lw042OnPopupOpen          = window.a219OnPopupOpen;
  window.lw042OnPopupClose         = window.a219OnPopupClose;
  window.lw042ValidateSides        = window.a219ValidateSides;
  window.lw042AppendSideProperties = window.a219AppendSideProperties;
  window.lw042ConfirmHtml          = window.a219ConfirmHtml;
  window.lw042EnhanceConfirmOptions = window.a219EnhanceConfirmOptions;
})(jQuery);
